import { render, staticRenderFns } from "./ManageRateTemplate.vue?vue&type=template&id=2acebc70&scoped=true"
import script from "./ManageRateTemplate.vue?vue&type=script&lang=js"
export * from "./ManageRateTemplate.vue?vue&type=script&lang=js"
import style0 from "./ManageRateTemplate.vue?vue&type=style&index=0&id=2acebc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acebc70",
  null
  
)

export default component.exports